import ReactGA from 'react-ga4'
import { Link } from 'react-router-dom'

export const ButtonDecoSmall = ({ children, link, gaCategory, gaLabel, onClickEvent, active }) => {
    return (
        <>
            <button
                onClick={
                    (() => {
                        ReactGA.event({
                            action: 'click',
                            event: 'link',
                            category: { gaCategory },
                            label: { gaLabel },
                        })
                    },
                    onClickEvent)
                }
                to={link}
                activeclassname='active'
                className={`${
                    active
                        ? 'bg-pborange  text-white duration-500 border-white border-2'
                        : 'bg-pbdarkorange duration-500 border-white border-2'
                } relative w-[47%] lg:w-full font-humming text-button tracking-wider h-[2.8rem] lg:mr-4  min-w-[160px] hover:text-white hover:bg-pborange border-2 border-pbnavy hover:border-2 hover:duration-300 text-white align-middle flex flex-wrap justify-center lg:justify-between items-center`}
            >
                <em className='not-italic whitespace-nowrap px-2 w-auto text-sub md:text-caption'>{children}</em>
                {active && (
                    <em>
                        <i class='hidden lg:block translate-x-full'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='9' height='14' viewBox='0 0 9 14'>
                                <path d='M7,0l7,9H0Z' transform='translate(9) rotate(90)' fill='rgb(217, 79, 0)'></path>
                            </svg>
                        </i>
                    </em>
                )}
            </button>
        </>
    )
}
export const ButtonLine = ({ text, color, link, gaCategory, gaLabel }) => {
    return (
        <button
            className={`border-y border-${color} px-20 py-2 mb-4 relative hover:text-reygold duration-300 ease-in-out linedeco-button`}
        >
            <p className='uppercase'>
                {' '}
                <Link
                    onClick={() => {
                        ReactGA.event({
                            action: 'click',
                            event: 'link',
                            category: { gaCategory },
                            label: { gaLabel },
                        })
                    }}
                    to={link}
                    activeclassname='active'
                    className='buttonlink'
                >
                    {text}
                </Link>
            </p>
        </button>
    )
}
export const ButtonLineSmall = ({ text }) => {
    return (
        <button className={`px-12 py-2 my-4 relative linedeco-button min-w-[240px]`}>
            <h3 className='text-center text-gradient-title text-lg font-pop'>{text}</h3>{' '}
        </button>
    )
}
export const ButtonRetailer = ({ dataPlatform, dataUrl, dataStore }) => {
    return (
        <button className={`retailer-button hover:brightness-150 duration-300`}>
            <a
                onClick={() => {
                    ReactGA.event({
                        action: 'click',
                        event: 'link',
                        category: 'Products',
                        label: `DE ${dataPlatform} ${dataStore}`,
                    })
                }}
                target='_blank'
                rel='noreferrer'
                href={`${dataUrl}`}
            >
                <p>{dataStore}</p>
            </a>
        </button>
    )
}
